import "core-js";
import SweetScroll from 'sweet-scroll';
import {
  matchHeight,
  awaitSelector,
  watchAwaitSelector,
  throttle,
  debounce,
  setHeaderOffsetPadding,
  getViewport,
  setHeightAuto,
  makeSquareFromWidth,
  makeSquareFromHeight,
  insertAfter,
  equalHeights
} from "./functions";

// Media breakpoint, defined in functions.php and _foundation_settings.scss
// If you make changes to any of them, be sure to update the others!
const breakpoints = {
  medium: 600,
  mediumlarge: 850,
  large: 1024,
  xlarge: 1200,
  xxlarge: 1440,
  xxxlarge: 1550
};

// Custom global scripts
jQuery(document).ready(
  (function($) {
    "use strict";

    // Foundation Init
    $(document).foundation();

    // Mobile nav toggle
    $("#nav-mobile-toggle").on("click", function() {
      $("#nav-mobile").slideToggle();
    });

    const video = document.querySelector("video");
    if (video) {
      video.addEventListener("ended", function() {
        video.classList.add("done");
      });
    }

    // ====================================================== //
    // ============== Mobile menu toggle on/off ============= //
    // ====================================================== //
    const mobileToggle = document.getElementById("mobile-toggle");
    if (mobileToggle) {
      mobileToggle.addEventListener("click", function(e) {
        mobileToggle.parentNode.classList.toggle("active");
      });
    }

    $(window).on("changed.zf.mediaquery", function(event, newSize, oldSize) {
      // Once at medium-large or above, close mobile menu
      switch (newSize) {
        case "medium-large":
        case "large":
        case "xlarge":
        case "xxlarge":
          document
            .querySelector(".header__nav--mobile")
            .classList.remove("active");
          break;
      }
    });


    var firstLoad = true;
    window.almComplete = function(alm) {
      if(firstLoad === true) {
        let allFilter = document.getElementById('radio--1');
        if(allFilter && !window.location.search) {
          allFilter.click();
          allFilter.classList.add('active');
          firstLoad = false;
        }
      }
    };

    watchAwaitSelector(function() {
      const projectsPagination = document.querySelector(".alm-paging.paging");
      const prevButton = projectsPagination.querySelector(".prev");
      const nextButton = projectsPagination.querySelector(".next");

      const prevArrow = `<svg class="svg svg--pagination svg--prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="#b2b2b2" d="M0 6l6.161-6 1.255.667-4.867 4.725H12v1.21H2.542l4.874 4.73L6.16 12z"/></svg>`;
      const nextArrow = `<svg class="svg svg--pagination vg--next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="#b2b2b2" d="M4.736 11.329l4.88-4.739H.156V5.4H9.61L4.736.667 5.989 0l6.157 5.998-6.157 5.998z"/></svg>`;

      let customPagination = document.createElement("li");
      customPagination.setAttribute("id", "customPagination");
      customPagination.classList.add("pages");

      if (prevButton) {
        let prevButtonContent = prevButton.querySelector("span");
        prevButtonContent.innerHTML = prevArrow;

        let max = projectsPagination.dataset.totalPages;
        let current = projectsPagination.dataset.currentPage;

        let html = makeCustomAlmPagination(current, max);

        // Add the new element after the "prev" arrow (happens once)
        insertAfter(customPagination, prevButton);

        let newEl = document.getElementById("customPagination");
        if (newEl) {
          // Insert the numbers into the new element
          newEl.innerHTML = html;

          window.almComplete = function(alm) {
            current = projectsPagination.dataset.currentPage;
            html = makeCustomAlmPagination(current, max);

            newEl.innerHTML = html;
          };
        }
      }

      if (nextButton) {
        let nextButtonContent = nextButton.querySelector("span");
        nextButtonContent.innerHTML = nextArrow;
      }
    }, ".alm-btn-wrap > .alm-paging > li.prev");

    if (document.querySelectorAll(".card--team > .card__content")) {
      equalHeights(".card--team > .card__content");

      window.addEventListener(
        "resize",
        debounce(function() {
          equalHeights(".card--team > .card__content");
        }, 500)
      );
    }

    function makeCustomAlmPagination(current, max) {
      current = new Number(current);
      max = new Number(max);

      if (current < 10) {
        current = `0${current}`;
      }

      if (max < 10) {
        max = `0${max}`;
      }

      let html = `<span class="current">${current}</span><span class="slash">/</span><span class="max">${max}</span>`;

      return html;
    }
    
    
    const landingNavbar = document.getElementById('landing-navbar');
    if(landingNavbar) {
      let sections = [];
      const links = landingNavbar.querySelectorAll("a");
      const config = {
        threshold: 1.0
      };

      for (const link of links) {
        let id = link.href.split("#")[1];

        // If target anchor, and anchor exists
        if (id && document.getElementById(id)) {
          sections.push(document.getElementById(id));
        }
      }
      
      
      // Build the observer
      let observer = new IntersectionObserver(function(entries, self) {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            intersectionHandler(entry);
          }
        }
      }, config);

      // Observe the anchor sections
      for (const section of sections) {
        observer.observe(section);
      }
      
      // Add/remove active class to secondary nav (anchor) links
      function intersectionHandler(entry) {
        const id = entry.target.id;
        const currentlyActive = landingNavbar.querySelector("a.active");
        const shouldBeActive = landingNavbar.querySelector(`a[href='#${id}']`);

        if (currentlyActive) {
          currentlyActive.classList.remove("active");
        }
        if (shouldBeActive) {
          shouldBeActive.classList.add("active");
        }
      }
      const scroller = new SweetScroll({
        /* some options */
      });
    }

      // News popup - home page 
    if (!localStorage.getItem('newsPopup')) {
      if ($('#news-popup').length) {
        setTimeout(function () {
          $('#news-popup').foundation('open');
          localStorage.setItem('newsPopup', 'opened');
        }, 3000);
      }
    }

  
 
    
  })(jQuery)
);

//Slider
const slider = document.querySelector(".slideshow-container");

if(slider) {
  const slidePrevBtn = document.querySelector(".slide-prev");
  const slideNextBtn = document.querySelector(".slide-next");
  slidePrevBtn.addEventListener("click", function(e) {
    e.preventDefault();
    plusSlides(-1);
  });

  slideNextBtn.addEventListener("click", function(e) {
    e.preventDefault();
    plusSlides(1);
  });

  let slideIndex = 1;
  showSlides(slideIndex);

  // Next/previous controls
  function plusSlides(n) {
    showSlides((slideIndex += n));
  }

  function showSlides(n) {
    let i;
    const slides = document.getElementsByClassName("slide");
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slides[slideIndex - 1].style.display = "block";
  }
}

const projectsPage = document.getElementsByClassName('page-id-18');
if (!projectsPage) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const scroller = new SweetScroll();
      const hash = window.location.hash;
      const needsInitialScroll = document.getElementById(hash.substr(1)) != null;
  
  
      if (needsInitialScroll) {
        window.location.hash = '';
      }
  
      window.addEventListener(
        'load',
        () => {
          if (needsInitialScroll) {
            scroller.to(hash, { updateURL: 'replace' });
          }
        },
        false,
      );
    },
    false,
  );
}
